import { render, staticRenderFns } from "./DecorativeList.vue?vue&type=template&id=b49f346e&scoped=true&"
import script from "./DecorativeList.vue?vue&type=script&lang=js&"
export * from "./DecorativeList.vue?vue&type=script&lang=js&"
import style0 from "./DecorativeList.vue?vue&type=style&index=0&id=b49f346e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49f346e",
  null
  
)

export default component.exports